import { useState, useEffect, useContext, useRef } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import type { Address } from "./types";
import { fetchAddress, fetchUtility, getConfigById } from "./api/api";
import { EnrollmentContext } from "./enrollment";
import { Trans, useTranslation } from "react-i18next";
import InvalidZipcode from "./pages/modals/InvalidZipcode";
import { useModal } from "./cro/context/CroModalContext";

export const ValidateAddress = ({
  handleSearchUtility,
  loadingUtility,
  isFromCro,
  setValidAddress
}: {
  handleSearchUtility: Function;
  loadingUtility: boolean;
  isFromCro?: boolean;
  setValidAddress: Function;
}) => {
  const { t } = useTranslation("enrollment");
  const { t: tCro }  = useTranslation("cro");
  const [searching, setSearching] = useState(false);
  const [addressOptions, setAddressOptions] = useState<Address[]>([]);
  const [selectedAddress, setSelectedAddress] = useState<Address[]>([]);
  const {
    changeServiceAddress,
    loading,
    serviceAddress,
    handleSetErrorModalContent,
  } = useContext<any>(EnrollmentContext);
  const [residentialCustomersOnly, setResidentialCustomersOnly] =
    useState(false);
  const inputRef = useRef<any>();
  const { showModal } = useModal();

  useEffect(() => {
    (async () => {
      let res = await getConfigById("RESIDENTIAL_CUSTOMERS_ONLY");
      const flag = Boolean(Number(res?.config_details?.ConfigData));
      setResidentialCustomersOnly(flag);
    })();
  }, []);

  useEffect(() => {
    if (selectedAddress.length === 0) return;

    if (isFromCro) {
      const urlParams = new URLSearchParams(window.location.search);
      const zipCode = selectedAddress[0]?.zipcode;
      const utilityId =
        urlParams.get("utility_id") ||
        urlParams.get("utilityId") ||
        urlParams.get("utilityid");
      (async () => {
        await fetchUtility(zipCode).then(
          (res: { status: number; response: { utility: any } }) => {
            if (res && res.status === 1) {
              const { utility } = res.response;
              const hasUtility = utility.some(
                (u: { id_utility: number }) =>
                  u.id_utility === Number(utilityId)
              );
              if (hasUtility) {
                setValidAddress(true);
                handleSearchUtility(selectedAddress[0]);
              } else {
                setValidAddress(false);
                showModal(
                  {
                    title: tCro(`invalidZipCodeUtility`, {
                      zipCode: zipCode,
                    }),
                  },
                  {
                    content: <InvalidZipcode />,
                  },
                  {
                    size: "lg",
                  }
                );
                changeServiceAddress(undefined);
                setSelectedAddress([]);
              }
            }
          }
        );
      })();
    } else {
      setValidAddress(true);
      handleSearchUtility(selectedAddress[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAddress]);

  const handleSearch = (val: string) => {
    setSearching(true);
    fetchAddress(val).then((data) => {
      setAddressOptions(data);
      setSearching(false);
    });
  };

  return (
    <>
      <div className="autocomplete-address-row">
        <div id="autocomplete-wrapper">
          <AsyncTypeahead
            ref={inputRef}
            filterBy={() => true}
            id="autocomplete"
            isLoading={searching || loadingUtility}
            labelKey="label"
            minLength={1}
            onSearch={handleSearch}
            options={addressOptions}
            placeholder={`${t("Address")}...`}
            size="lg"
            onChange={(val) => {
              setSelectedAddress(val);

              if (
                val.length > 0 &&
                val[0]?.premise_type !== "Residential" &&
                residentialCustomersOnly
              ) {
                setSelectedAddress([]);
                changeServiceAddress(undefined);
                handleSetErrorModalContent({
                  title: <Trans i18nKey="enrollment:nonResidential" components={{ 1: <a href="tel:8883556205" style={{
                    color: "#253f66",
                  }}>888-355-6205</a> }} />,
                  desc: " ",
                });
              } else {
                changeServiceAddress(val[0] ? val[0] : undefined);
              }

              if (val.length > 0) {
                inputRef.current.blur();
              }
            }}
            selected={
              selectedAddress.length > 0
                ? selectedAddress
                : serviceAddress
                ? [serviceAddress]
                : []
            }
            disabled={loading}
          />
        </div>
      </div>
      {selectedAddress[0] && (
        <p
          style={{ fontSize: 12, marginTop: 8, marginLeft: 4, color: "#666" }}
        >{`ESIID: ${selectedAddress[0].esiid}`}</p>
      )}
    </>
  );
};
